// FETCH SEGMENTS
export const FETCH_SEGMENT_LIST = 'segments/FETCH_SEGMENT_LIST';
export const FETCH_SEGMENT_LIST_DATA = 'segments/FETCH_SEGMENT_LIST_DATA';
export const FETCH_SEGMENT_LIST_ERROR = 'segments/FETCH_SEGMENT_LIST_ERROR';

// CREATE NEW SEGMENT
export const CREATE_NEW_SEGMENT = 'segments/CREATE_NEW_SEGMENT';
export const CREATE_NEW_SEGMENT_SUCCESS = 'segments/CREATE_NEW_SEGMENT_SUCCESS';
export const CREATE_NEW_SEGMENT_ERROR = 'segments/CREATE_NEW_SEGMENT_ERROR';

// EDIT SEGMENT
export const EDIT_SEGMENT = 'segments/EDIT_SEGMENT';
export const EDIT_SEGMENT_SUCCESS = 'segments/EDIT_SEGMENT_SUCCESS';
export const EDIT_SEGMENT_ERROR = 'segments/EDIT_SEGMENT_ERROR';
